import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment } from '@material-ui/core';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 320,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

JobCostToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  currentTab: PropTypes.string,
};

export default function JobCostToolbar({ numSelected, filterName, onFilterName,currentTab }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const placeholderText = currentTab === 'Services' ? 'Search Services...' : 'Search Materials...';

  /** Local value so typing does not re-render the parent on every keystroke; parent updated debounced */
  const [localFilter, setLocalFilter] = useState(filterName || '');
  const debounceRef = useRef();

  useEffect(() => {
    setLocalFilter(filterName || '');
  }, [filterName]);

  useEffect(() => () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
  }, []);

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setLocalFilter(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onFilterName({ ...event, target: { ...event.target, value } });
    }, 200);
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'var(--signwise-app-chrome-toolbar)' : 'var(--signwise-app-chrome-toolbar)'
        })
      }}
    >

        <SearchStyle
        sx={{backgroundColor:'var(--signwise-app-chrome-toolbar)'}}
          value={localFilter}
          onChange={handleFilterChange}
          placeholder={placeholderText}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
    </RootStyle>
  );
}
